import React, { useState } from 'react'
import { Box, Drawer, Tooltip } from '@mui/material'
import HistoryIcon from '@mui/icons-material/History'
import { useTranslation } from 'react-i18next'
import { SquareButton } from '../../styles/ButtonStyles'
import { Dayjs } from 'dayjs'
import { User } from '../../store/types'
import WorkHoursModificationHistoryComponent from '../../components/Worklog/WorkHoursModificationHistoryComponent'

interface WorkHoursHistoryViewProps {
  selectedUser: User | null
  selectedDate: Dayjs
}

const WorkHoursHistoryView: React.FC<WorkHoursHistoryViewProps> = ({ selectedUser, selectedDate }) => {
  const [isHistoryVisible, setIsHistoryVisible] = useState(false)
  const { t } = useTranslation()
  return (
    <Box>
      <Tooltip title={t('components.tooltip.scheduleModificationHistory')}>
        <span>
          <SquareButton
            color="secondary"
            onClick={() => setIsHistoryVisible(true)}
            aria-label={t('components.tooltip.scheduleModificationHistory')}
          >
            <HistoryIcon />
          </SquareButton>
        </span>
      </Tooltip>
      <Drawer
        anchor="right"
        open={isHistoryVisible}
        onClose={() => setIsHistoryVisible(false)}
        PaperProps={{ sx: { bgcolor: 'background.main', overflow: 'hidden' } }}
      >
        <WorkHoursModificationHistoryComponent
          selectedDate={selectedDate}
          onLeaveButtonClick={() => setIsHistoryVisible(false)}
          selected={selectedUser}
        />
      </Drawer>
    </Box>
  )
}

export default WorkHoursHistoryView
